var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg106Target(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,236h-19.908c-4.574-50.146-26.311-96.689-62.357-132.735C373.45,66.979,326.527,45.194,276,40.819V20 c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v21.002c-49.765,4.77-95.929,26.457-131.735,62.263 C68.219,139.311,46.482,185.854,41.908,236H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h21.908 c4.574,50.146,26.311,96.689,62.357,132.735c35.806,35.806,81.97,57.492,131.735,62.263V492c0,11.046,8.954,20,20,20 s20-8.954,20-20v-20.839c29.669-2.621,58.616-11.346,84.666-25.622c9.687-5.308,13.236-17.464,7.928-27.15 c-5.308-9.688-17.464-13.236-27.15-7.928c-20.177,11.056-42.499,18.022-65.443,20.51V390c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20v40.754C155.37,421.125,91.306,356.766,82.13,276H122c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20 H82.13C91.306,155.234,155.37,90.875,236,81.246V122c0,11.046,8.954,20,20,20s20-8.954,20-20V81.019 C357.569,89.814,422.618,154.567,431.87,236H390c-11.046,0-20,8.954-20,20s8.954,20,20,20h41.84 c-2.847,24.492-10.893,48.292-23.686,69.763c-5.653,9.489-2.545,21.765,6.944,27.418c9.487,5.653,21.764,2.546,27.419-6.945 c16.49-27.676,26.551-58.532,29.541-90.237H492c11.046,0,20-8.954,20-20C512,244.953,503.046,236,492,236z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg106Target);
export default __webpack_public_path__ + "static/media/106-target.96c171857671c234692f66479b74ff47.svg";
export { ForwardRef as ReactComponent };